import { z } from 'zod';
/** Calendar date in YYYY-MM-DD (UTC). */
export const networkCalendarDaySchema = z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/, 'Expected YYYY-MM-DD')
    .refine((value) => {
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}, 'Expected a valid calendar date');
/** Calendar month in YYYY-MM. */
export const networkCalendarMonthSchema = z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Expected YYYY-MM');
/**
 * Params for `getNetworkCalendar`.
 * - `month` — all approved entries in that UTC month
 * - `day` — a specific UTC day (`YYYY-MM-DD`) or `"today"` for the current UTC day
 * - `chain` — network/chain slug as stored in usersdb `networks.network` (e.g. `"ethereum"`)
 * When both `month` and `day` are set, `day` must fall within `month`.
 */
export const getNetworkCalendarParamsSchema = z
    .object({
    month: networkCalendarMonthSchema.optional(),
    day: z.union([networkCalendarDaySchema, z.literal('today')]).optional(),
    chain: z.string().min(1).optional(),
})
    .strict()
    .superRefine((value, ctx) => {
    if (!value.month || !value.day || value.day === 'today')
        return;
    if (!value.day.startsWith(`${value.month}-`)) {
        ctx.addIssue({
            code: 'custom',
            message: '"day" must fall within the provided "month"',
            path: ['day'],
        });
    }
});
/** Public chain environment for a calendar entry (mapped from DB `mn` / `tn` / `dn`). */
export const networkCalendarChainTypeSchema = z.enum(['mainnet', 'testnet', 'devnet']);
export const networkCalendarEventTypeSchema = z.enum(['release', 'upgrade']);
/** One approved network calendar entry (public shape). */
export const networkCalendarEntrySchema = z
    .object({
    id: z.number().int().positive(),
    chain: z.string().min(1),
    date: z.string().min(1),
    description: z.string(),
    chainType: networkCalendarChainTypeSchema,
    eventType: networkCalendarEventTypeSchema,
})
    .strict();
export const getNetworkCalendarDataSchema = z
    .object({
    entries: z.array(networkCalendarEntrySchema),
})
    .strict();
